import * as React from 'react';
import { WebGivingMerchant, MerchantCardPreference } from '../../webgiving-generated';
import { Text } from '../../components/text';

export class PagePaymentMethodSupportedDescription extends React.Component<{ merchant: WebGivingMerchant, supportsCard: boolean }, {}> {
	render() {
		const { merchant: { CardPreference, TradingName, SupportsAch, PaymentLabel }, supportsCard } = this.props;
		let supportedDescription: string = '';

		if(SupportsAch) {
			if(supportsCard) {
				switch (CardPreference) {
					case MerchantCardPreference.AnyCard:
						supportedDescription = 'accepts debit cards, credit cards and bank transfers.';
						break;
					case MerchantCardPreference.DebitPreferred:
						supportedDescription = `prefers debit cards or bank transfers for ${PaymentLabel.VerbPresentTenseLowerCase} but also accepts other supported cards.`;
						break;
					case MerchantCardPreference.DebitOnly:
						supportedDescription = 'accepts debit cards and bank transfers only.';
						break;
				}
			} else {
				supportedDescription = 'accepts bank transfers only.';
			}
		} else {
			switch (CardPreference) {
				case MerchantCardPreference.AnyCard:
					supportedDescription = 'accepts debit cards and credit cards.';
					break;
				case MerchantCardPreference.DebitPreferred:
					supportedDescription = `prefers debit cards for ${PaymentLabel.VerbPresentTenseLowerCase} but also accepts other supported cards.`;
					break;
				case MerchantCardPreference.DebitOnly:
					supportedDescription = `only accepts debit cards for ${PaymentLabel.VerbPresentTenseLowerCase}.`;
					break;
			}
		}

		return <span>{TradingName} <Text>{supportedDescription}</Text></span>;
	}
}
